import React from 'react';
import {
  Box,
  HStack,
  Button,
  Icon,
  Badge,
  useColorModeValue,
} from '@chakra-ui/react';
import { FiX, FiEdit3, FiTag, FiUserPlus, FiTrash2, FiPrinter, FiZap, FiBriefcase } from 'react-icons/fi';

export default function BulkActionsBar({ 
  count, 
  onChangeStage, 
  onAddTag, 
  onAssign, 
  onDelete, 
  onClear,
  hasAssignedDeals = false,
  isAllSelected = false,
  onSendPostcard = null, // optional — renders only when provided
  onEnrollCampaign = null, // optional — enrolls the deals' contacts (Dashboard / My Deals)
  onSetRecordScope = null, // optional + admin-only — company/personal record scope
}) {
  const bg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  return (
    <Box
      position="fixed"
      bottom={6}
      left="50%"
      transform="translateX(-50%)"
      bg={bg}
      borderWidth="2px"
      borderColor={borderColor}
      borderRadius="xl"
      shadow="2xl"
      px={6}
      py={4}
      zIndex={1000}
      minW="600px"
      data-tour="deals-bulk-bar"
    >
      <HStack spacing={4} justify="space-between">
        <HStack spacing={3}>
          <Badge colorScheme={isAllSelected ? "green" : "blue"} fontSize="md" px={3} py={1}>
            {isAllSelected ? `All ${count.toLocaleString()} selected` : `${count.toLocaleString()} selected`}
          </Badge>
          
          <Button
            size="sm"
            leftIcon={<Icon as={FiEdit3} />}
            onClick={onChangeStage}
            variant="ghost"
          >
            Change Stage
          </Button>
          
          <Button
            size="sm"
            leftIcon={<Icon as={FiTag} />}
            onClick={onAddTag}
            variant="ghost"
          >
            Add Tag
          </Button>
          
          <Button
            size="sm"
            leftIcon={<Icon as={FiUserPlus} />}
            onClick={onAssign}
            variant="ghost"
          >
            {hasAssignedDeals ? 'Reassign' : 'Assign'}
          </Button>

          {onSetRecordScope && (
            <Button
              size="sm"
              leftIcon={<Icon as={FiBriefcase} />}
              onClick={onSetRecordScope}
              variant="ghost"
              colorScheme="purple"
            >
              Scope
            </Button>
          )}

          {onEnrollCampaign && (
            <Button
              size="sm"
              leftIcon={<Icon as={FiZap} />}
              onClick={onEnrollCampaign}
              variant="ghost"
              colorScheme="purple"
            >
              Enroll in Campaign
            </Button>
          )}

          {onSendPostcard && (
            <Button
              size="sm"
              leftIcon={<Icon as={FiPrinter} />}
              onClick={onSendPostcard}
              variant="ghost"
              colorScheme="green"
            >
              Send Postcard
            </Button>
          )}
          
          <Button
            size="sm"
            leftIcon={<Icon as={FiTrash2} />}
            onClick={onDelete}
            variant="ghost"
            colorScheme="red"
          >
            Delete
          </Button>
        </HStack>

        <Button
          size="sm"
          leftIcon={<Icon as={FiX} />}
          onClick={onClear}
          variant="ghost"
        >
          Clear
        </Button>
      </HStack>
    </Box>
  );
}

